import React, { useMemo, useState } from "react";

import classNames from "classnames";

import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";

import { CarouselButtonNextIcon } from "~/components/common/Icons/CarouselButtonNextIcon";
import { CarouselButtonPreviousIcon } from "~/components/common/Icons/CarouselButtonPreviousIcon";
import { VideoPlayer } from "~/components/videoProductPage/common/VideoPlayer/VideoPlayer";
import { getResponsiveImageURL } from "~/util/cloudinary-utils";
import { convertSecondsToVideoPlayerDuration } from "~/util/stringUtils";

import * as styles from "./VideoChaptersSection.css";
import { PropsInterface, SWIPE_SLIDER_STYLES } from "./VideoChaptersSectionInterface";

const allStyles = {
  [SWIPE_SLIDER_STYLES.LIGHT]: {
    buttonGradient: styles.buttonGradientLight,
    navigationButtonAdditional: styles.navigationButtonLight,
    arrowIconColor: "#757575",
  },
  [SWIPE_SLIDER_STYLES.DARK]: {
    buttonGradient: styles.buttonGradientDark,
    navigationButtonAdditional: styles.navigationButtonDark,
    arrowIconColor: "#fff",
  },
};

export const VideoChaptersSection = ({
  productData,
  videos,
  styleType = SWIPE_SLIDER_STYLES.LIGHT,
}: PropsInterface): React.ReactElement => {
  const additionalStyles = useMemo(() => {
    return allStyles[styleType as keyof typeof SWIPE_SLIDER_STYLES];
  }, []);

  const onCLickSlider = () => {

  };

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  return (
    <div className={styles.outerContainer}>
      <div className={styles.container}>
        <div className={styles.carouselContainer}>
          <div>
            <div id="instructor-carousel">
              <button
                className={classNames(
                  styles.navigationButton,
                  styles.buttonPrevious,
                  additionalStyles.navigationButtonAdditional,
                  isBeginning && styles.arrowVisibility,
                  "swiper-button-prev-prod",
                )}
              >
                <CarouselButtonPreviousIcon fill={additionalStyles.arrowIconColor} />
              </button>
              <button
                className={classNames(
                  styles.navigationButton,
                  styles.buttonNext,
                  additionalStyles.navigationButtonAdditional,
                  isEnd && styles.arrowVisibility,
                  "swiper-button-next-prod",
                )}
              >
                <CarouselButtonNextIcon fill={additionalStyles.arrowIconColor} />
              </button>
              <Swiper
                modules={[Navigation]}
                slidesPerView={"auto"}
                navigation={{
                  nextEl: `.swiper-button-next-prod`,
                  prevEl: `.swiper-button-prev-prod`,
                }}
                allowTouchMove={false}
                spaceBetween={25}
                initialSlide={0}
                threshold={5}
                onTransitionEnd={(swiper) => {
                  setIsEnd(swiper.isEnd);
                  setIsBeginning(swiper.isBeginning);
                }}
                onInit={(swiper) => {
                  swiper.allowTouchMove = swiper.width <= 991;
                  setIsEnd(swiper.isEnd);
                  setIsBeginning(swiper.isBeginning);
                }}
                onResize={(swiper) => {
                  swiper.allowTouchMove = swiper.width <= 991;
                }}
              >
                {videos.map((video, index) => (
                  <SwiperSlide
                    key={`videoitem__${index}`}
                    className={styles.videoSlide}
                    onClick={onCLickSlider}
                  >
                    <div className={classNames(styles.productBuyPreviewImage, "video")}>
                      <div className={styles.videoThumbnail}>
                        <VideoPlayer
                          disabled={true}
                          url="https://"
                          light={
                            getResponsiveImageURL(video.previewImageUrl, "280") ||
                            getResponsiveImageURL(productData.productImageURL, "280")
                          }
                          height={104}
                          playIcon={
                            <div className={styles.videoDuration}>
                              {convertSecondsToVideoPlayerDuration(video.lengthInSeconds)}
                            </div>
                          }
                        />
                      </div>
                      <p className={styles.videoSlideText}>
                        {index + 1}. {video.title}
                      </p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
        <div
          className={classNames(
            isBeginning ? "" : styles.prevButtonGradient,
            additionalStyles.buttonGradient,
          )}
        />
        <div
          className={classNames(
            isEnd ? "" : styles.nextButtonGradientFirst,
            additionalStyles.buttonGradient,
          )}
        />
      </div>
    </div>
  );
};
